import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Stopa } from './stopa';
import { ActivatedRoute } from '@angular/router';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-stopa-update',
  templateUrl: './stopa-update.component.html'
})
export class StopaUpdateComponent extends BaseUpdateComponent<Stopa> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("TarifaID", Validators.required, 'required', 'STOPA.TARIFAID.VALIDATION.REQUIRED');
    this.addValidatorToFc("Datum", Validators.required, 'required', 'STOPA.DATUM.VALIDATION.REQUIRED');
    this.addValidatorToFc("Iznos", Validators.required, 'required', 'STOPA.IZNOS.VALIDATION.REQUIRED');
  }

}
